import { IonCard } from "@ionic/react";
import LevelsRankTitleTicked, { RankTitleTickedProps } from "./LevelsRankTitle";

export interface LevelsCardProps {
  rankIcon: string;
  title: string;
  titleColor: string;
  rankList: RankTitleTickedProps[];
}

const LevelsCard: React.FC<LevelsCardProps> = ({
  rankIcon,
  title,
  titleColor,
  rankList
}) => {
  return (
    // TODO: FIX the card border
    <IonCard>
      <div className="flex items-center bg-primary-90">
        <div className="flex items-center">
          <div className="ml-2 mt-2 mr-2 mb-2">
            <img src={rankIcon} alt="level icon" />
          </div>
          <span className={`text-l font-bold text-${titleColor}`}>{title}</span>
        </div>
      </div>
      <div className="bg-primary-90 p-2">
        {rankList.map(rankProps => (
          <LevelsRankTitleTicked
            key={rankProps.rank}
            playerLevel={rankProps.playerLevel}
            rank={rankProps.rank}
            title={rankProps.title}
            ticked={rankProps.ticked}
          />
        ))}
      </div>
    </IonCard>
  );
};

export default LevelsCard;
